module.exports = __webpack_public_path__ + "static/img/video-bg.ffddfaf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/video-bg.png
// module id = 7cX7
// module chunks = 96